import * as Yup from 'yup';
import { notAllowedWord, reservedValues } from '../../../common/formElements/reservedKeywords';
export const getFieldDataTypeValue = (fieldName, fieldData, stateFieldDatatypes) => {
  if (stateFieldDatatypes[fieldName]) {
    return stateFieldDatatypes[fieldName];
  }

  const dataType = fieldData[fieldName];
  let result;
  switch (dataType) {
    case 'text':
    case 'string':
    case 'link':
    case 'multiple':
    case 'singleLineText':
    case 'multilineText':
    case 'singleCollaborator':
    case 'singleSelect':
    case 'multipleSelects':
    case 'multipleRecordLinks':
    case 'reference':
    case 'picklist':
    case 'currency':
    case 'address':
    case 'double':
    case 'url':
    case 'textarea':
    case 'phone':
    case 'encryptedstring':
    case 'email':
    case 'anyType':
    case 'time':
    case 'percent':
    case 'base64':
    case 'point':
    case 'varchar':
    case 'longtext':
    case 'char':
      result = {
        label: 'String',
        value: 'text',
      };
      break;
    case 'number':
    case 'int':
    case 'integer':
    case 'phoneNumber':
    case 'numeric':
    case 'bigint':
    case 'uuid':
    case 'serial':
    case 'float':
    case 'decimal':
    case 'tinyint':
      result = {
        label: 'Number',
        value: 'number',
      };
      break;
    case 'date':
    case 'datetime':
    case 'timestamp without time zone':
    case 'timestamp':
      result = {
        label: 'Date',
        value: 'date',
      };
      break;
    case 'boolean':
    case 'bit':
      result = {
        label: 'Boolean',
        value: 'boolean',
      };
      break;
    case 'json':
    case 'blob':
      result = {
        label: 'File',
        value: 'file',
      };
      break;
    default:
      result = {
        label: dataType,
        value: dataType,
      };
      break;
  }

  return result;
};

export const getFieldDataTypeValueSupabase = (fieldName, fieldData, stateFieldDatatypes) => {
  if (stateFieldDatatypes[fieldName]) {
    return stateFieldDatatypes[fieldName];
  }
  const dataType = fieldData[fieldName];
  switch (dataType) {
    case 'text':
    case 'point':
      return {
        label: 'String',
        value: 'text',
      };
    case 'integer':
    case 'numeric':
    case 'number':
    case 'phoneNumber':
    case 'int':
    case 'bigint':
    case 'uuid':
    case 'serial':
      return {
        label: 'Number',
        value: 'number',
      };
    case 'boolean':
      return {
        label: 'Boolean',
        value: 'boolean',
      };
    case 'date':
    case 'datetime':
    case 'timestamp without time zone':
      return {
        label: 'Date',
        value: 'date',
      };
    default:
      return {
        label: dataType,
        value: dataType,
      };
  }
};

export const convertAttributesToFieldData = (attributes) => {
  const fieldData = {};
  for (const attribute of attributes) {
    const { key, type } = attribute;
    let fieldType = '';

    switch (type) {
      case 'string':
        fieldType = 'text';
        break;
      case 'integer':
        fieldType = 'number';
        break;
      case 'datetime':
        fieldType = 'date';
        break;
      default:
        fieldType = type;
    }

    fieldData[key] = fieldType;
  }

  return fieldData;
};

export const prepareValidationForAppwrite = () => {
  let validationSchema = {
    dataSourceName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    appwriteProjectid: Yup.string().required('This field is required'),
    appwriteAPIKey: Yup.string().required('This field is required'),
  };
  return Yup.object().shape(validationSchema);
};

export const prepareValidationForXata = () => {
  let validationSchema = {
    dataSourceName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    xataAPIKey: Yup.string().required('This field is required'),
  };
  return Yup.object().shape(validationSchema);
};

export const prepareValidationForXataTables = () => {
  let validationSchema = {
    tableName: Yup.string().required('This field is required'),
  };
  return Yup.object().shape(validationSchema);
};

export const findRegionByName = (nameToFind, data) => {
  const item = data.find((item) => item.name === nameToFind);
  return item ? item.region : null;
};

export const convertFields = (data) => {
  const convertedData = {};

  for (const [key, value] of Object.entries(data)) {
    switch (value) {
      case 'text':
      case 'string':
      case 'link':
      case 'multiple':
      case 'singleLineText':
      case 'multilineText':
      case 'singleCollaborator':
      case 'singleSelect':
      case 'multipleSelects':
      case 'multipleRecordLinks':
      case 'reference':
      case 'picklist':
      case 'currency':
      case 'address':
      case 'double':
      case 'url':
      case 'textarea':
      case 'phone':
      case 'encryptedstring':
      case 'email':
      case 'anyType':
      case 'time':
      case 'percent':
      case 'base64':
      case 'point':
      case 'varchar':
      case 'char':
      case 'longtext':
        convertedData[key] = 'text';
        break;
      case 'int':
      case 'number':
      case 'int':
      case 'integer':
      case 'phoneNumber':
      case 'numeric':
      case 'bigint':
      case 'uuid':
      case 'serial':
      case 'float':
      case 'decimal':
      case 'tinyint':
        convertedData[key] = 'number';
        break;
      case 'date':
      case 'datetime':
      case 'timestamp without time zone':
      case 'timestamp':
        convertedData[key] = 'date';
        break;
      case 'boolean':
      case 'bit':
        convertedData[key] = 'boolean';
        break;
      case 'json':
      case 'blob':
        convertedData[key] = 'file';
        break;
      default:
        convertedData[key] = value;
    }
  }
  return convertedData;
};

export const prepareValidationForDirectus = () => {
  let validationSchema = {
    dataSourceName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    userToken: Yup.string().required('This field is required'),
    baseUrl: Yup.string().required('This field is required'),
  };
  return Yup.object().shape(validationSchema);
};

export const filterCollections = (collections) =>
  collections
    .filter((collection) => !collection.collection.toLowerCase().includes('directus'))
    .map((collection) => ({ name: collection.collection, fields: '' }));

export const prepareValidationForAirtable = () => {
  let validationSchema = {
    dataSourceName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    userToken: Yup.string().required('This field is required'),
  };
  return Yup.object().shape(validationSchema);
};
export const filterXanoCollection = (collections) => {
  return collections.map(({ name }) => ({ name, fields: '' }));
};
export const transformData = (originalData) => {
  return originalData.map((item) => {
    const fieldsObj = item.fields.reduce((acc, field) => {
      acc[field.name] = field.type;
      return acc;
    }, {});

    return {
      collectionName: item.name,
      collectionId: item.id,
      fields: fieldsObj,
    };
  });
};

export const findFieldsByCollectionId = (data, collectionId) => {
  const foundTable = data.find((table) => table.collectionId === collectionId);
  return foundTable ? foundTable.fields : null;
};

export const findTableByCollectionId = (data, collectionId) => {
  const completeData = data.completeData ? data.completeData : null;
  const tables = completeData.tables;
  const foundTable = tables.find((table) => table.collectionId === collectionId);
  return foundTable ? foundTable : null;
};

const commonValidationSchema = () => {
  return Yup.string()
    .required("Name can't be blank")
    .matches(/^[0-9A-Za-z\s]+$/, 'Name should not contain special characters or numbers.')
    .max(100, `Name can\'t be more than 100 characters`)
    .test('reserved', 'This is a reserved word please use another', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !reservedValues.includes(lowercaseValue);
    })
    .test('not-allowed', 'This type of word is not allowed.', (value) => {
      const lowercaseValue = value ? value.toLowerCase() : '';
      return !notAllowedWord.includes(lowercaseValue);
    });
};

export const prepareValidationForDerivedField = () => {
  return Yup.object().shape({
    functionName: commonValidationSchema(),
  });
};

export const prepareValidationForValidationCreate = () => {
  return Yup.object().shape({
    customValidationName: commonValidationSchema(),
  });
};

export const prepareValidationForCustomConstant = () => {
  return Yup.object().shape({
    name: commonValidationSchema(),
  });
};
export const clearSpaceAndReformat = (text, separator) => {
  if (!text) {
    return '';
  }
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, separator ? separator : '');
};
export const cleanCollectionAndFieldName = (str) => {
  str = str.replace(/[^a-zA-Z0-9 ]/, '');
  return str;
};

export const formatCollectionAndFieldName = (str) => {
  let updateString = cleanCollectionAndFieldName(str);
  return clearSpaceAndReformat(updateString.trim(), '_');
};

export const prepareValidationForMysql = () => {
  let validationSchema = {
    dataSourceName: Yup.string()
      .required("Data Source Name can't be blank")
      .max(100, 'Name can not be more than 100 characters')
      .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers')
      .test('reserved', 'This is reserved word please use another', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !reservedValues.includes(lowercaseValue);
      })
      .test('not-allowed', 'This type of word not allowed.', (value) => {
        const lowercaseValue = value ? value.toLowerCase() : '';
        return !notAllowedWord.includes(lowercaseValue);
      }),
    mysqlDbHostUrl: Yup.string().required('This field is required'),
    mysqlDbUser: Yup.string().required('This field is required'),
    mysqlDbPassword: Yup.string().required('This field is required'),
    mysqlDbName: Yup.string().required('This field is required'),
    mysqlDbPort: Yup.number().required('This field is required'),
  };
  return Yup.object().shape(validationSchema);
};

export const prepareValidationForMysqlCollection = (isExistingCollection) => {
  let validationSchema = {};
  if (isExistingCollection) {
    validationSchema = {
      collectionName: Yup.object().nullable().required('This field is required'),
      collectionTitle: Yup.string().required('This field is required'),
    };
  } else {
    validationSchema = {
      collectionTitle: Yup.string().required('This field is required'),
    };
  }

  return Yup.object().shape(validationSchema);
};
